import InputText from './inputText.jsx'

export default InputText
